/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import cx from 'classnames';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PolicyService , MLTransactionDiffService, UserService  } from 'gw-capability-gateway';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { JobUtil, DatatableUtil } from '@xengage/gw-portals-util-js';
import MLAccountPendingPolicyChangesComponent from '../../Components/MLAccountPendingPolicyChangesComponent/MLAccountPendingPolicyChangesComponent';

import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { withMLModalService } from 'ml-portals-services-react';
import { withMLNotificationBlockUtil, MLNotificationBlockUtil, MLDriverVehicleUtil  } from 'ml-portals-util-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import moment from 'moment';
import MLPolicySummaryDetailsComponent from '../../Components/MLPolicySummaryDetailsComponent/MLPolicySummaryDetailsComponent';
import MLInsured from './MLInsured/MLInsured';
import MLAdditionalInterests from './MLAdditionalInterests/MLAdditionalInterests';
import MLTransactionDiffPopup from './MLTransactionDiff/MLTransactionDiffPopup'
import MLTransactionDiffListPopup from './MLTransactionDiff/MLTransactionDiffListPopup'

import MLDrivers from './pa/MLDrivers/MLDrivers';
import MLExcludedDrivers from './pa/MLExcludedDrivers/MLExcludedDrivers';
import MLHouseholdMembers from './pa/MLHouseholdMembers/MLHouseholdMembers';
import MLVehicleCoverages from './pa/MLVehicleCoverages/MLVehicleCoverages';
import MLVehicles from './pa/MLVehicles/MLVehicles';
import MLRentedTDCVehicles from './pa/MLRentedTDCVehicles/MLRentedTDCVehicles';

import MLDiscountsIncludedFeatures from './ho/MLDiscountsIncludedFeatures/MLDiscountsIncludedFeatures';
import MLExclusions from './ho/MLExclusions/MLExclusions';
import MLHOPConstruction from './ho/MLHOPConstruction/MLHOPConstruction';
import MLHOPCoverages from './ho/MLHOPCoverages/MLHOPCoverages';
import MLHOPOptionalCoverages from './ho/MLHOPOptionalCoverages/MLHOPOptionalCoverages';
import MLHOPSpecialLimitations from './ho/MLHOPSpecialLimitations/MLHOPSpecialLimitations';

import MLUmbrellaBusinessActivityExposures from './umb/MLUmbrellaBusinessActivityExposures/MLUmbrellaBusinessActivityExposures';
import MLUmbrellaCoverage from './umb/MLUmbrellaCoverage/MLUmbrellaCoverage';
import MLUmbrellaDrivers from './umb/MLUmbrellaDrivers/MLUmbrellaDrivers';
import MLUmbrellaExclusions from './umb/MLUmbrellaExclusions/MLUmbrellaExclusions';
import MLUmbrellaLocationExposures from './umb/MLUmbrellaLocationExposures/MLUmbrellaLocationExposures';
import MLUmbrellaOptionalCoverage from './umb/MLUmbrellaOptionalCoverage/MLUmbrellaOptionalCoverage';
import MLUmbrellaUnderlyingPolicies from './umb/MLUmbrellaUnderlyingPolicies/MLUmbrellaUnderlyingPolicies';
import MLUmbrellaVehicleExposures from './umb/MLUmbrellaVehicleExposures/MLUmbrellaVehicleExposures';
import MLUmbrellaWatercraftExposures from './umb/MLUmbrellaWatercraftExposures/MLUmbrellaWatercraftExposures';
import MLUmbrellaWatercraftOperators from './umb/MLUmbrellaWatercraftOperators/MLUmbrellaWatercraftOperators';
import MLCoveragesUtil from './util/MLCoveragesUtil';

import metadata from './MLSummary.metadata.json5';
import styles from './MLSummary.module.scss';
import messages from './MLSummary.messages';
import gatewayMessages from '../../gateway.messages';

import { Button, Chevron } from '@jutro/legacy/components';

import { Link } from '@jutro/router';

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

const { 
    addWarningAlert,
    clearWarningAlerts,
    clearBlockAlerts 
} = MLNotificationBlockUtil();

const MERCER_AGENT = 'mercer';
const {
    isDriverHousehold
} = MLDriverVehicleUtil();
function clearSearchResultsWarning() {
    clearBlockAlerts('max_search_results_message');
}

function getCell(items, index, property) {
    return items[property.id];
}

function transactionTypeIsViewableInXCenter(transaction) {
    return (
        transaction.type.toLowerCase() !== 'reinstatement'
        && transaction.type.toLowerCase() !== 'rewrite'
    );
}

function canUserOpenJobInXCenter(transaction) {
    return transaction.canUserView && transactionTypeIsViewableInXCenter(transaction);
}

class MLSummary extends Component {
    static propTypes = {
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string
                })
            })
        }).isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func.isRequired,
            clone: PropTypes.func.isRequired,
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired,
    };

    static contextType = TranslatorContext;

    state = {
        policyData: '',
        insuredsVM: {},
        driverDetailsOpen: {},
        vehicleDetailsOpen: {},
        periodNavigation: {},
        transactionDiffData: {},
        isComparisonPopupOpen: false,
        transactionDiffTree: {},
        rentedTDCDetailsOpen: {},
        isSecondComparisonPopupOpen: false,
        organization: null
    };

    componentDidMount = () => {
        this.setPolicyCoveragesDetails();
        this.initStateVariables();
        clearSearchResultsWarning();
        this.canUserSeeMercerMessageBanner();
    };

    componentDidUpdate(preProp) {
        const {
            fromAccountLanding: { policyDetailsData }
        } = this.props;

        if (!_.isEqual(policyDetailsData, preProp.fromAccountLanding.policyDetailsData)) {
            this.setPolicyCoveragesDetails();
            this.initStateVariables();
        }
    }

    canUserSeeMercerMessageBanner() {
    UserService.getCurrentUser(this.props.authHeader).then((user) => {
      if (user && user.primaryProducerCode_ML && user.primaryProducerCode_ML.organization_ML) {
        this.setState({
          organization: user.primaryProducerCode_ML.organization_ML
        });
      }
    });
}

    getPolicySummaryFromAccount = ({policyNumber, account: { policySummaries }}) => {
        return policySummaries.filter((policy) => policy.policyNumber === policyNumber)[0];
    };

    displayWarningMessageForDelinquency = ({policyNumber, delinquent, isCancelled}) => {
        this.props.notificationBlockUtil.clearWarningAlerts();
        if (delinquent && !isCancelled) {
            const translator = this.context;
            const errorMsg = translator(messages.delinquencyWarning, {policyNumber: policyNumber});
            this.props.notificationBlockUtil.addWarningAlert(errorMsg, `non_payment_${policyNumber}`);
        };
    };

    displayWarningMessageForConversion = (periods) => {
        let isIsEAConversionSent_Ext = false;
        let gwpcNumber_Ext = '';

        periods.forEach((period) => {
            if(period?.isIsEAConversionSent_Ext && (period.gwpcPolicyNumber_Ext || period.gwpcJobNumber_Ext)) {
                isIsEAConversionSent_Ext = period.isIsEAConversionSent_Ext;
                gwpcNumber_Ext = period.gwpcPolicyNumber_Ext ? period.gwpcPolicyNumber_Ext : period.gwpcJobNumber_Ext;
            }
        })

        clearWarningAlerts();
        if (isIsEAConversionSent_Ext) {
            const message = { ...messages.conversionWarning, args: {
                policyNumber: gwpcNumber_Ext
            }};
            addWarningAlert(message, 'conversionWarning');
        };
    };

    setPeriodDefaults = (period) => {
        const {
            viewModelService
        } = this.props;
        const {
            insuredsVM,
            driverDetailsOpen,
            vehicleDetailsOpen,
            rentedTDCDetailsOpen
        } = this.state;

        period.namedInsureds_ML.forEach((insured) => {
            insuredsVM[insured.publicID] = viewModelService.create(insured, 'pc',
                'edge.capabilities.gateway.contact.dto.PersonDTO');
            insured.contactNumbers = [insured.cellNumber, insured.homeNumber, insured.workNumber,
                insured.faxNumber];
            insured.contactEmailAddresses = [insured.emailAddress1, insured.emailAddress2_ML];
            if (insured.primaryPhoneType === 'home') {
                insured.contactNumbers = insured.contactNumbers.splice(1, 1).concat(insured.contactNumbers);
            } else if (insured.primaryPhoneType === 'work') {
                insured.contactNumbers = insured.contactNumbers.splice(2, 1).concat(insured.contactNumbers);
            }
        });
        period.primaryNamedInsureds_ML = period.namedInsureds_ML.filter((ni) => !ni.isAdditionalNamedInsuredOtherCandidates_ML);
        this.setCommonComputedProperties(period);
        if (period.lobs_ML.personalAuto) {
            this.setPAComputedProperties(period);
            period.drivers_ML.forEach((driver) => {
                driverDetailsOpen[driver.publicID_ML] = false;
            });
            period.vehicles_ML.forEach((vehicle) => {
                vehicleDetailsOpen[vehicle.publicID_ML] = false;
                rentedTDCDetailsOpen[vehicle.publicID_ML] = false;
            });
        } else if (period.lobs_ML.personalUmbrella) {
            this.setPUPComputedProperties(period);
        }

        // Set a common additional interests array
        if (period.lobs_ML.homeowners) {
            period.additionalInterests = period.lobs_ML.homeowners.additionalInterests;
        } else if (period.lobs_ML.personalUmbrella) {
            period.additionalInterests = period.lobs_ML.personalUmbrella.additionalInterests;
        }
    };

    initStateVariables = () => {
        const {
            fromAccountLanding: { policyDetailsData }
        } = this.props;

        this.initNavigation();

        const data = {
            transaction1: undefined,
            transaction2: undefined,
            transactionList1: [],
            transactionList2: []
        };
        this.setState({transactionDiffData: data});

        policyDetailsData.policyResponse.periods.forEach((period) => {
            this.setPeriodDefaults(period);
        });

        const policySummary = this.getPolicySummaryFromAccount(policyDetailsData.policyResponse);
        if (policySummary) {
            this.displayWarningMessageForDelinquency(policySummary);
        }
        this.displayWarningMessageForConversion(policyDetailsData.policyResponse.periods);
    };

    getNextSetOfPeriodsAndUpdateNavigation = (policy, getFutureBoundPeriods, navigation, authHeader) => {
        const updateNavigation = () => {
            policy.periods.sort((a, b) => {
                if (MLLocalDateUtil.isEqual(a.editEffectiveDate_ML, b.editEffectiveDate_ML)) {
                    return (new Date(a.createTime_ML) - new Date(b.createTime_ML));
                }
                return MLLocalDateUtil.compare(a.editEffectiveDate_ML, b.editEffectiveDate_ML);
            });

            navigation.periods = policy.periods;
            navigation.currentIndex = navigation.periods.findIndex((p) => p.publicID === navigation.current.publicID);
            navigation.current = navigation.periods[navigation.currentIndex];
            navigation.size = policy.periods.length;
            if (getFutureBoundPeriods) {
                navigation.isLoadingRight = false;
            } else {
                navigation.isLoadingLeft = false;
            }
            this.setState({periodNavigation: navigation});
        };

        let partition = [];
        let isLatestPeriodInPartition = false;

        if (getFutureBoundPeriods) {
            partition = policy.listOfFutureBoundPeriods.splice(0, policy.policyPeriodRequestPartitionSize_Ext).map((item) => item.publicID);
            const latestPeriodIndexInPartition = _.findIndex(partition, (publicID) => publicID === policy.latestPeriod.publicID);
            if (latestPeriodIndexInPartition > -1) {
                partition.splice(latestPeriodIndexInPartition, 1);
                isLatestPeriodInPartition = true;
                if (partition.length === 0) {
                    this.setPeriodDefaults(policy.latestPeriod);
                    policy.periods.push(policy.latestPeriod);
                    updateNavigation();
                    return;
                }
            }
        } else {
            partition = policy.listOfBoundPeriods.splice(0, policy.policyPeriodRequestPartitionSize_Ext).map((item) => item.publicID);
        }

        PolicyService.getPolicyPeriodsByPublicID(policy.policyNumber, partition, authHeader).then((policyPeriodResults) => {
            if (isLatestPeriodInPartition) {
                policyPeriodResults.push(policy.latestPeriod);
            }
            policyPeriodResults.forEach((period) => {
                this.setPeriodDefaults(period);
            });
            policy.periods = _.concat(policy.periods, policyPeriodResults);
            updateNavigation();
        });
    };

    initNavigation = () => {
        const {
            fromAccountLanding: { policyDetailsData },
            authHeader
        } = this.props;

        policyDetailsData.policyResponse.periods.sort((a, b) => {
            if (MLLocalDateUtil.isEqual(a.editEffectiveDate_ML, b.editEffectiveDate_ML)) {
                return (new Date(a.createTime_ML) - new Date(b.createTime_ML));
            }
            return MLLocalDateUtil.compare(a.editEffectiveDate_ML, b.editEffectiveDate_ML);
        });

        const currentDate = MLLocalDateUtil.date2LocalDate(new Date());
        let index;
        for (index = policyDetailsData.policyResponse.periods.length; index > 0; index--) {
            if (MLLocalDateUtil.compare(currentDate, policyDetailsData.policyResponse.periods[index - 1].editEffectiveDate_ML) >= 0) {
                break;
            }
        }

        const navigation = {
            periods: policyDetailsData.policyResponse.periods,
            size: policyDetailsData.policyResponse.periods.length,
            currentIndex: index > 0 ? index - 1 : 0
        };
        navigation.current = navigation.periods[navigation.currentIndex];
        navigation.hasRight = () => navigation.currentIndex < navigation.size - 1;
        navigation.hasLeft = () => navigation.currentIndex > 0;
        navigation.goRight = () => {
            navigation.current = navigation.periods[++navigation.currentIndex];
            this.setState({periodNavigation: navigation});

            if (!navigation.hasRight() && policyDetailsData.policyResponse.listOfFutureBoundPeriods && policyDetailsData.policyResponse.listOfFutureBoundPeriods.length > 0) {
                navigation.isLoadingRight = true;
                this.getNextSetOfPeriodsAndUpdateNavigation(policyDetailsData.policyResponse, true, navigation, authHeader);
            }
        };
        navigation.goLeft = () => {
            navigation.current = navigation.periods[--navigation.currentIndex];
            this.setState({periodNavigation: navigation})

            if (!navigation.hasLeft() && policyDetailsData.policyResponse.listOfBoundPeriods.length > 0) {
                navigation.isLoadingLeft = true;
                this.getNextSetOfPeriodsAndUpdateNavigation(policyDetailsData.policyResponse, false, navigation, authHeader);
            }
        };
        this.setState({ periodNavigation: navigation });
    };

    setCommonComputedProperties = (period) => {
        let includedFeatures;
        let exclusionCoverages;

        const filterIncludedFeatures = () => {
            const filteredFeatures = {};

            includedFeatures && includedFeatures.forEach((feature) => {
                if (filteredFeatures[feature.code_ML] === undefined) {
                    filteredFeatures[feature.code_ML] = feature;
                }
            });
            return Object.values(filteredFeatures);
        };

        if (!period.hasOwnProperty('includedFeatures_ML')) {
            Object.defineProperty(period, 'includedFeatures_ML', {
                get: function () {
                    if (!includedFeatures) {
                        includedFeatures = MLCoveragesUtil.getIncludedFeatures(period.lobs_ML);
                    }

                    return filterIncludedFeatures();
                }
            });
        }
        if (!period.hasOwnProperty('exclusionCoverages_ML')) {
            Object.defineProperty(period, 'exclusionCoverages_ML', {
                get: function () {
                    if (!exclusionCoverages) {
                        exclusionCoverages = MLCoveragesUtil.getExclusions(period.lobs_ML);
                    }
                    return exclusionCoverages;
                }
            });
        }
    };

    setPAComputedProperties = (period) => {
        let coverages;
        let navigation;
        const initVehicleNavigation = () => {
            const vehicles = period.lobs_ML.personalAuto.vehicleCoverages;
            const window = 3;
            const newNavigation = {
                elements: vehicles,
                size: vehicles.length,
                currentIndex: 0
            };
            newNavigation.current = vehicles.slice(newNavigation.currentIndex, newNavigation.currentIndex + window);
            newNavigation.filter = (value, index) => index >= newNavigation.currentIndex && index < newNavigation.currentIndex + window;
            newNavigation.hasRight = () => (newNavigation.currentIndex + window) < newNavigation.size;
            newNavigation.hasLeft = () => newNavigation.currentIndex > 0;
            // eslint-disable-next-line no-return-assign
            newNavigation.goRight = () => newNavigation.current = vehicles.slice(++newNavigation.currentIndex, newNavigation.currentIndex + window);
            // eslint-disable-next-line no-return-assign
            newNavigation.goLeft = () => newNavigation.current = vehicles.slice(--newNavigation.currentIndex, newNavigation.currentIndex + window);
            newNavigation.isActive = newNavigation.hasRight();
            return newNavigation;
        };

        if (!period.hasOwnProperty('vehicleCoverages_ML')) {
            Object.defineProperty(period, 'vehicleCoverages_ML', {
                get: function () {
                    if (!coverages) {
                        coverages = MLCoveragesUtil.getVehicleCoverages(period.lobs_ML.personalAuto);
                    }
                    return coverages;
                }
            });
        }
        if (!period.hasOwnProperty('vehNavigation_ML')) {
            Object.defineProperty(period, 'vehNavigation_ML', {
                get: function () {
                    if (!navigation) {
                        navigation = initVehicleNavigation();
                    }
                    return navigation;
                }
            });
        }
        period.lobs_ML.personalAuto.vehicleCoverages.forEach((vehCov) => {
            if (!vehCov.hasOwnProperty('monthlyCost_ML')) {
                Object.defineProperty(vehCov, 'monthlyCost_ML', {
                    get: function () {
                        return {
                            amount: vehCov.vehicleCost_ML.amount /
                                ((period.termType_ML === 'Annual') ? 12 : 6),
                            currency: vehCov.vehicleCost_ML.currency
                        };
                    }
                });
            }
        });
    };

    setPUPComputedProperties = (period) => {
        let optionalCoverages;
        let exclusions;
        let ulCoverages;
        const {
            viewModelService
        } = this.props;

        if (!period.hasOwnProperty('pupOptionalCoverages_ML')) {
            Object.defineProperty(period, 'pupOptionalCoverages_ML', {
                get: function () {
                    if (!optionalCoverages) {
                        optionalCoverages = MLCoveragesUtil.getPUPOptionalCoverages(period.lobs_ML.personalUmbrella, viewModelService);
                    }
                    return optionalCoverages;
                }
            });
        }
        if (!period.hasOwnProperty('pupExclusions_ML')) {
            Object.defineProperty(period, 'pupExclusions_ML', {
                get: function () {
                    if (!exclusions) {
                        exclusions = MLCoveragesUtil.getPUPExclusions(period.lobs_ML.personalUmbrella);
                    }
                    return exclusions;
                }
            });
        }
        if (!period.hasOwnProperty('pupULCoverages_ML')) {
            Object.defineProperty(period, 'pupULCoverages_ML', {
                get: function () {
                    if (!ulCoverages) {
                        ulCoverages = MLCoveragesUtil.getPUPULCoverages(period.lobs_ML.personalUmbrella);
                    }
                    return ulCoverages;
                }
            });
        }
    };

    setPolicyCoveragesDetails = () => {
        const {
            fromAccountLanding: { policyDetailsData }
        } = this.props;
        const policyData = _.cloneDeep(policyDetailsData.policyResponse);
        this.setState({ policyData });
    };

    getFormattedCurrency = (value) => {
        let formattedAmount = '';
        const { intl } = this.props;
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency
                    }
                );
            }
        }
        return formattedAmount;
    };

    getSearchFilterValues = (transactionData, keyword) => {
        const lowerCaseFilterValue = keyword.toLocaleLowerCase();
        return _.filter(transactionData, (res) => {
            return Object.keys(res).some(
                (key) => typeof res[key] === 'string'
                    && res[key].toLocaleLowerCase().includes(lowerCaseFilterValue)
            );
        });
    };

    getJobNumberLink = (item, index, property) => {
        if (canUserOpenJobInXCenter(item)) {
            if (this.showOpenJobInXCenter(item)) {
                return (
                    <Link
                        href="/"
                        onClick={() => JobUtil.openJobInXCenter(item.jobNumber)}
                    >
                        {item[property.id]}
                    </Link>
                );
            }
            return (
                <Link to={JobUtil.getJobDetailURLByJobType(item.type, item.jobNumber)}>
                    {item[property.id]}
                </Link>
            );
        }
        return <span>{item.jobNumber}</span>;
    };

    showOpenJobInXCenter = (item) => {
        return (
            item.type !== 'Submission'
            && item.type !== 'PolicyChange'
            && item.type !== 'Cancellation'
            && item.type !== 'Renewal'
        );
    };

    onChangePolicy = async () => {
        const { policyData } = this.state;
        const { fromAccountLanding, history } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const { lobEndorsementURL, endorsementProducts } = appConfig;
        const productCode = _.get(policyData, 'product.productCode');
        if (endorsementProducts.includes(productCode)) {
            history.push(lobEndorsementURL[productCode], { policyNumber });
        } else {
            this.setState({ disableChangePolicyLink: false });
        }
    };

    getJobNumber = async (policyNumber) => {
        const { authHeader } = this.props;
        const renewalVM = await PolicyService.createNewPolicyRenewalTransaction(
            [policyNumber],
            authHeader
        );
        return _.get(renewalVM, 'jobNumber');
    };

    onRenewalPolicy = async () => {
        const { fromAccountLanding, history } = this.props;
        const { lobRenewalURL } = appConfig;
        const policy = _.get(fromAccountLanding, 'policyDetailsData.policyResponse');
        const policyNumber = _.get(policy, 'policyNumber');
        const lobCode = _.get(policy, 'latestPeriod.policyLines[0].lineOfBusinessCode');
        const jobNumber = await this.getJobNumber(policyNumber);
        if (!_.isEmpty(lobRenewalURL[lobCode])) {
            history.push(lobRenewalURL[lobCode], { jobNumber });
        } else {
            JobUtil.openJobInXCenter(jobNumber);
        }
    };

    getResponse = async () => {
        const result = await PolicyService.getPolicy();
        return result;
    };

    getHeaderSection = (title) => {
        return (isOpen) => (
            <React.Fragment>
                <Chevron isOpen={isOpen} align="right" />
                <h2 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            </React.Fragment>
        );
    };

    isGeneralCoverage = () => {
        const { policyData } = this.state;
        return (
            [
                'PersonalAuto',
                'Homeowners',
                'HOPHomeowners',
                'homeowners',
                'HomeownersLine_HOE'
            ].indexOf(policyData.product.productCode) === -1
        );
    };

    getPolicyTransactionStatus = () => {
        return [
            {
                code: 'all',
                name: gatewayMessages.all
            },
            {
                code: 'Draft',
                name: {
                    id: 'typekey.PolicyPeriodStatus.Draft',
                    defaultMessage: 'Draft'
                }
            }
        ];
    };

    generateOverrides = () => {
        const { policyData } = this.state;
        const overrides = policyData.coverables.map((coverable, i) => {
            return {
                [`namesGrid${i}`]: {
                    visible: !_.isEmpty(coverable.coverages)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    getDateString = (date) => {
        return moment(date).format('MM/DD/YYYY');
    }

    getTransactionDiffListPopup = () => {
        const {
            isSecondComparisonPopupOpen,
            transactionDiffTree
        } = this.state;

        const componentProps = {
            transactions: transactionDiffTree.jobTransactions,
            diff: transactionDiffTree.diffNodes,
            isOpen: isSecondComparisonPopupOpen,
            onReject: () => this.setState({isSecondComparisonPopupOpen: false}),
        };
        return <MLTransactionDiffListPopup {...componentProps} />;

    }

    getTransactionDiffPopup = () => {
        const {
            policyData,
            isComparisonPopupOpen,
            transactionDiffData
        } = this.state;
        const { authHeader } = this.props;

        const getDiff = (data) => {
            // check dates to make sure the earlier effective date shows on the left side of the comparison modal
            if (MLLocalDateUtil.localDate2Date(data.transaction1.effDate) < MLLocalDateUtil.localDate2Date(data.transaction2.effDate)) {
                return MLTransactionDiffService.getDiffBetweenJobs(data.transaction2.jobNumber, data.transaction1.jobNumber, policyData.policyNumber, authHeader);
            }
            return MLTransactionDiffService.getDiffBetweenJobs(data.transaction1.jobNumber, data.transaction2.jobNumber, policyData.policyNumber, authHeader);
        };

        const onClickDiffButton = async (data) => {
            const diff = await getDiff(data);
            this.setState({
                isComparisonPopupOpen: false,
                isSecondComparisonPopupOpen: true,
                transactionDiffTree: diff
            });
        };

        if (isComparisonPopupOpen) {
            const componentProps = {
                data: transactionDiffData,
                policyNumber: policyData.policyNumber,
                onSaveAction: (data) => onClickDiffButton(data),
                isOpen: isComparisonPopupOpen,
                onReject: () => this.setState({isComparisonPopupOpen: false}),
                onResolve: () => this.setState({isComparisonPopupOpen: false}),
            };
            return <MLTransactionDiffPopup {...componentProps} />;
        };
        return null;
    };

    render() {
        const {
            policyData,
            driverDetailsOpen,
            vehicleDetailsOpen,
            periodNavigation,
            insuredsVM,
            isComparisonPopupOpen,
            isSecondComparisonPopupOpen,
            rentedTDCDetailsOpen,
            organization
        } = this.state;
        const translator = this.context;
        const period = periodNavigation.current;
        const custServicingPhoneNumber = _.get(policyData, 'latestPeriod.custServicingPhoneNumber', '')

        if (period === undefined) {
            return null;
        }

        const interestTypeDisplayMap = {
            'FIRSTMORTGAGEE': translator(messages.MortgageCompany),
            'SECONDMORTGAGEE':translator(messages.MortgageCompany),
            'THIRDMORTGAGEE':translator(messages.MortgageCompany),
            'LEASINGCOMPANY':translator(messages.LeasingCompany),
            'LIEN':translator(messages.LienholderCompany),
            'LESSOR':translator(messages.LessorCompany),
            'additional_insured_slp_ml':translator(messages.AdditionalInsured),
            'TRUST_ML':translator(messages.Trust),
            'thirdparty_ml':translator(messages.ThirdParty),
            'ADDITIONALINSURED_ML':translator(messages.AdditionalInsured),
            'joint_ownership_ml':translator(messages.JointOwnership),
            'additional_interest_ml':translator(messages.AdditionalInterest),
            'CONDOASSOC_ML':translator(messages.CondoAssociation),
            'HOMEOWNERSASSOC_ML': translator(messages.HomeownersAssociation)

        };

        const generatePAOverrides = () => {
            if (period.lobs_ML.personalAuto === undefined) {
                return {};
            }
            const vehicles = period?.vehicles_ML ?? [];

            const rentedTDCList = vehicles
                .map(vehicle => vehicle.rentedTDCVehicles_ML)   
                .filter(Boolean);         


            const isModernProduct = _.get(period, "isModernProduct_Ext", false);
            const houseHoldMembers = isModernProduct ? period.drivers_ML.filter((d) => isDriverHousehold(d))  : period.householdMembers_ML;
            const overrides = {
                paDriversComponent: {
                    data: period.drivers_ML,
                    driverDetailsOpen,
                    show: period.drivers_ML !== undefined && period.drivers_ML.length > 0
                },
                paExcludedDriversComponent: {
                    data: period.excludedDrivers_ML,
                    show: period.excludedDrivers_ML !== undefined && period.excludedDrivers_ML.length > 0 && period.canExcludeDrivers_ML
                },
                paHouseholdMembersComponent: {
                    data: isModernProduct ? period.drivers_ML.filter((d) => isDriverHousehold(d)) : period.householdMembers_ML,
                    show: houseHoldMembers !== undefined && houseHoldMembers.length > 0,
                    isModernProduct
                },
                paVehiclesComponent: {
                    data: period.vehicles_ML,
                    vehicleDetailsOpen,
                    interestTypeDisplayMap,
                    getFormattedCurrency: this.getFormattedCurrency,
                    show: period.vehicles_ML !== undefined && period.numberOfVehicles_ML > 0
                },
                paVehicleCoveragesComponent: {
                    period,
                    getFormattedCurrency: this.getFormattedCurrency,
                    show: period.vehicleCoverages_ML !== undefined
                },
                paRentedTDCComponent: {
                    visible: period.isModernProduct_Ext && period.lobs_ML.personalAuto,
                    data: period.vehicles_ML,
                    rentedTDCDetailsOpen,
                    show: rentedTDCList.length > 0
                }
            };
            return overrides;
        };

        const generateHOOverrides = () => {
            if (period.lobs_ML.homeowners === undefined) {
                return {};
            }
            let shouldShowSpecialLimitations = true
            const HOPNewProduct = _.get(period, "isModernProduct_Ext", false);
            if(HOPNewProduct) {
                shouldShowSpecialLimitations = _.get(period, "shouldShowSpecialLimitations", true);
            }
            const overrides = {
                hopCoveragesComponent: {
                    data: period.lobs_ML.homeowners.baseCoverages,
                    fullTermCost_Ext: this.getFormattedCurrency(period.fullTermCost_Ext),
                    show: period.lobs_ML.homeowners !== undefined && period.lobs_ML.homeowners.baseCoverages.length > 0,
                    preQualHomeOccupancy: period?.preQualQuestionSets?.[0]?.answers?.HOPPreQualHomeCondoDwellingOccupancy_Ext,
                    isModernProduct :_.get(period, "isModernProduct_Ext", false)
                },
                hopOptionalCoveragesComponent: {
                    valuablePersonalProperties_ML: period.lobs_ML.homeowners.valuablePersonalProperties_ML,
                    schedulePersonalProperties_ML: period.lobs_ML.homeowners.schedulePersonalProperties_ML,
                    mineSubsidenceScheduledPvtStructureItem: period.lobs_ML.homeowners.mineSubsidenceScheduledPvtStructureItem,
                    optionalCoverages_ML: period.lobs_ML.homeowners.optionalCoverages_ML,
                    getFormattedCurrency: this.getFormattedCurrency,
                    show: period.lobs_ML.homeowners !== undefined &&
                        (_.get(period, 'lobs_ML.homeowners.schedulePersonalProperties_ML', []).length > 0 ||
                        _.get(period, 'lobs_ML.homeowners.valuablePersonalProperties_ML', []).length > 0 ||
                        _.get(period, 'lobs_ML.homeowners.optionalCoverages_ML', []).length > 0 ||
                        _.get(period, 'lobs_ML.homeowners.mineSubsidenceScheduledPvtStructureItem', []).length > 0)
                },
                hopSpecialLimitationsComponent: {
                    data: period.lobs_ML.homeowners.conditionCoverages_ML[0]?.terms,
                    show: period.lobs_ML.homeowners !== undefined &&
                        period.lobs_ML.homeowners.conditionCoverages_ML !== undefined &&
                        period.lobs_ML.homeowners.conditionCoverages_ML[0]?.terms &&
                        period.lobs_ML.homeowners.conditionCoverages_ML[0]?.terms.length > 0 &&
                        !(period.isModernProduct_Ext && (period?.policyProductCode_ML === "hop_landlord_condo_ml" || period?.policyProductCode_ML === "hop_landlord_home_ml")) &&
                        shouldShowSpecialLimitations === true
                },
                constructionComponent: {
                    data: period.constructionSummary_ML,
                    getFormattedCurrency: this.getFormattedCurrency,
                    show: period.constructionSummary_ML.constructionVerisk.replacementCost,
                    productCode: period.policyProductCode_ML,
                    policyNumber: period.policyNumber
                },

            };
            return overrides;
        };

        const generateUMBOverrides = () => {
            if (period.lobs_ML.personalUmbrella === undefined) {
                return {};
            }
            const overrides = {
                umbrellaCoverageComponent: {
                    data: period.lobs_ML.personalUmbrella.primaryCoverages,
                    getFormattedCurrency: this.getFormattedCurrency,
                    show: period.lobs_ML.personalUmbrella !== undefined
                },
                umbrellaOptionalCoverageComponent: {
                    period,
                    getFormattedCurrency: this.getFormattedCurrency,
                    show: (period.pupOptionalCoverages_ML !== undefined && period.pupOptionalCoverages_ML.length > 0) || period.lobs_ML.personalUmbrella.prsnlAutoExcessCoverages || period.lobs_ML.personalUmbrella.prsnlWatercraftExcessCoverages
                },
                umbrellaExclusionsComponent: {
                    data: period.pupExclusions_ML,
                    show: period.pupExclusions_ML !== undefined && period.pupExclusions_ML.length > 0
                },
                umbrellaDriversComponent: {
                    period,
                    show: period.pupVehOperators_ML !== undefined && period.pupVehOperators_ML.length > 0
                },
                umbrellaVehicleExposuresComponent: {
                    data: period.pupVehicles_ML,
                    show: period.pupVehicles_ML !== undefined && period.pupVehicles_ML.length > 0
                },
                umbrellaLocationExposuresComponent: {
                    data: period.pupLocations_ML,
                    show: period.pupLocations_ML !== undefined && period.pupLocations_ML.length > 0
                },
                umbrellaBusinessActivityComponent: {
                    data: period.pupBusActivities_ML,
                    show: period.pupBusActivities_ML !== undefined && period.pupBusActivities_ML.length > 0,
                    isModernProduct: period.isModernProduct_Ext
                },
                umbrellaWatercraftExposureComponent: {
                    data: period.pupWatercraft_ML,
                    show: period.pupWatercraft_ML !== undefined && period.pupWatercraft_ML.length > 0
                },
                umbrellaWatercraftOperatorsComponent: {
                    data: period.pupWCOperators_ML,
                    show: period.pupWCOperators_ML !== undefined && period.pupWCOperators_ML.length > 0
                },
                umbrellaUnderlyingPoliciesComponent: {
                    data: period.pupULCoverages_ML,
                    show: period.pupULCoverages_ML !== undefined && period.pupULCoverages_ML.length > 0
                }
            };
            return overrides;
        };

        const overrides = {
            policySummaryDetailsComponent: {
                policies: [periodNavigation.current],
                totalFees: period.totalCost.amount === period.fullTermCost_Ext.amount ? period.taxesAndFees : policyData.totalChanges_Ext,
                itemizedFees: period.totalCost.amount === period.fullTermCost_Ext.amount ? policyData.fullTermFeesCosts_Ext : policyData.feesCosts_Ext,
                hideSectionStyle: true,
                displayAlternativeTemplate: false
            },
            insuredComponent: {
                data: period.primaryNamedInsureds_ML.sort((insured) => insured.isPrimaryNamedInsured_ML),
                insuredsVM,
                show: period.primaryNamedInsureds_ML !== undefined,
                deedInfo_Ext: period?.deedInfo_Ext,
                dwellingDeedInfo_Ext: period?.dwellingDeedInfo_Ext,
                isModernProduct : period?.isModernProduct_Ext
            },
            pendingPolicyChangesComponent: {
                accountNumber: policyData.account.accountNumber,
                pendingPolicyChanges: policyData.pendingPolicyChangesML_Ext,
                updatePendingPolicyChanges: (pendingPolicyChanges) => {
                    const currentPolicyData = _.clone(policyData);

                    currentPolicyData.pendingPolicyChangesML_Ext = pendingPolicyChanges;
                    this.setState({policyData: currentPolicyData});
                },
                visible: !_.isEmpty(policyData.pendingPolicyChangesML_Ext),
                displayPolicyNumberColumn:false
            },
            line2: {
                visible: !_.isEmpty(policyData.pendingPolicyChangesML_Ext)
            },
            additionalInterestsComponent: {
                data: period.additionalInterests,
                interestTypeDisplayMap,
                show: period.additionalInterests !== undefined
            },
            discountsComponent: {
                data: period.discounts_ML,
                title: translator(messages.Discounts),
                show: period.discounts_ML !== undefined && period.discounts_ML.length > 0
            },
            includedFeaturesComponent: {
                data: period.includedFeatures_ML,
                title: translator(messages.IncludedFeatures),
                show: period.includedFeatures_ML !== undefined && period.includedFeatures_ML.length > 0
            },
            exclusionCoveragesComponent: {
                data: period.exclusionCoverages_ML,
                show: period.exclusionCoverages_ML !== undefined && period.exclusionCoverages_ML.length > 0
            },
            ...generatePAOverrides(),
            ...generateHOOverrides(),
            ...generateUMBOverrides()
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell: getCell,
                getJobNumberLink: this.getJobNumberLink,
                onChangePolicy: this.onChangePolicy,
                onRenewalPolicy: this.onRenewalPolicy,
                handleCancelButtonClick: this.handleCancelButtonClick,
                onDoNotCancel: this.onDoNotCancel,
                onDoNotChangePolicy: this.onDoNotChangePolicy,
                sortDate: DatatableUtil.sortDate,
                sortString: DatatableUtil.sortString,
                sortCurrency: DatatableUtil.sortCurrency,
                sortNumber: DatatableUtil.sortNumber,
                getFormattedCurrency: this.getFormattedCurrency
            },
            resolveComponentMap: {
                MLPolicySummaryDetailsComponent,
                insured: MLInsured,
                additionalinterests: MLAdditionalInterests,
                drivers: MLDrivers,
                excludeddrivers: MLExcludedDrivers,
                householdmembers: MLHouseholdMembers,
                vehiclecoverages: MLVehicleCoverages,
                vehicles: MLVehicles,
                discountsincludedfeatures: MLDiscountsIncludedFeatures,
                exclusions: MLExclusions,
                construction: MLHOPConstruction,
                hopcoverages: MLHOPCoverages,
                hopoptionalcoverages: MLHOPOptionalCoverages,
                speciallimitations: MLHOPSpecialLimitations,
                businessactivityexposures: MLUmbrellaBusinessActivityExposures,
                umbrellacoverage: MLUmbrellaCoverage,
                umbrelladrivers: MLUmbrellaDrivers,
                umbrellaexclusions: MLUmbrellaExclusions,
                locationexposures: MLUmbrellaLocationExposures,
                umbrellaoptionalcoverage: MLUmbrellaOptionalCoverage,
                underlyingpolicies: MLUmbrellaUnderlyingPolicies,
                umbrellavehicleexposures: MLUmbrellaVehicleExposures,
                watercraftexposures: MLUmbrellaWatercraftExposures,
                watercraftoperators: MLUmbrellaWatercraftOperators,
                MLAccountPendingPolicyChangesComponent,
                rentedTDC : MLRentedTDCVehicles
            },
        };
        const readValue = (id, path) => {
            return readViewModelValue(metadata.pageContent, policyData, id, path, overrides);
        };
        const transactionDiffClick = async () => {
            const { transactionDiffData } = this.state;
            const { authHeader } = this.props;
            const newData = transactionDiffData;
            if (transactionDiffData.transactionList1.length === 0) {
                const transactions = await MLTransactionDiffService.getTransactions(policyData.policyNumber, authHeader)
                transactions.forEach((t) => {
                    t.name = `${t.jobType} ${this.getDateString(t.effDate)}`;
                });
                newData.transactionList1 = transactions;
                newData.transaction1 = transactionDiffData.transactionList1.find((t) => t.current === true);
                newData.transactionList2 = transactionDiffData.transactionList1.filter((t) => t !== newData.transaction1);
            };
            this.setState({isComparisonPopupOpen: true, transactionDiffData: newData })
        };

        return (
            <React.Fragment>
                <MLAlertGroupComponent noWizard clearOnStepChange={false} className={styles.alertGroupComponent}/>
                <div className={styles.mlSummaryContent}>
                    <div className="row">
                        <div className="col-md-3">{ (organization?.name?.toLowerCase().includes(MERCER_AGENT)) &&
                            <b className={styles.mercerErrorContent}>{translator(messages.mercerErrorMessage, { custServicingPhoneNumber })}</b>
                        }</div>
                        <div className="col-md-6">
                            <ul className="pagination">
                                <li className={cx('pagination-prev')}>
                                    {!periodNavigation.isLoadingLeft && <Button
                                        disabled={!periodNavigation.hasLeft()}
                                        className={cx(
                                            "pagination-prev",
                                            { "disabled": !periodNavigation.hasLeft() }
                                        )}
                                        iconClassName={cx(
                                            "pagination-prev"
                                        )}
                                        type="filled"
                                        onClick={periodNavigation.goLeft}
                                    />}
                                    {periodNavigation.isLoadingLeft && <img className={styles.mlLoadingLeft} src='/throbber.gif' alt=''/>}
                                </li>
                                <li>
                                    <strong>{translator(messages.PolicyDate)}</strong>
                                    {this.getDateString(periodNavigation.current.editEffectiveDate_ML)}
                                </li>
                                <li className="pagination-next pagination-next--margin-left">
                                    {!periodNavigation.isLoadingRight && <Button
                                        disabled={!periodNavigation.hasRight()}
                                        className={cx(
                                            "pagination-next",
                                            "pagination-next--margin-left",
                                            { "disabled": !periodNavigation.hasRight() }
                                        )}
                                        type="filled"
                                        onClick={periodNavigation.goRight}
                                    />}
                                    {periodNavigation.isLoadingRight && <img className={styles.mlLoadingRight} src='/throbber.gif' alt=''/>}
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-3">
                            {true &&
                            <Button
                                disabled={false}
                                className={styles.pullRight}
                                type="outlined"
                                onClick={transactionDiffClick}
                            > {translator(messages.CompareTerm)}
                            </Button>
                            }
                        </div>
                    </div>
                    { isComparisonPopupOpen && this.getTransactionDiffPopup()}
                    { isSecondComparisonPopupOpen && this.getTransactionDiffListPopup()}
                    <ViewModelForm
                        uiProps={metadata.pageContent}
                        model={policyData}
                        overrideProps={overrides}
                        callbackMap={resolvers.resolveCallbackMap}
                        classNameMap={resolvers.resolveClassNameMap}
                        componentMap={resolvers.resolveComponentMap}
                        resolveValue={readValue}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export const SummaryComponent = MLSummary;
export default withMLNotificationBlockUtil(withMLModalService(withRouter(withIntl(withAuthenticationContext(withViewModelService(MLSummary))))));
